import { render, staticRenderFns } from "./taskInfo.vue?vue&type=template&id=5013fa24&scoped=true"
import script from "./taskInfo.vue?vue&type=script&lang=js"
export * from "./taskInfo.vue?vue&type=script&lang=js"
import style0 from "./taskInfo.vue?vue&type=style&index=0&id=5013fa24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5013fa24",
  null
  
)

export default component.exports